import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import PageLoader from '../common/PageLoader';
import Schedule from '../common/Schedule';
import { map, filter, indexOf } from 'lodash';
import moment from 'moment';
import { services, appBasePath } from '../../constants/staticData';
import InfiniteScroll from 'react-infinite-scroller';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchMobile: false,
      notificationVisible: false,
      showSidebar: false,
      isNotificationsLoaded: false
    };
    this.loadingMoreNotifications = false;
    this.renderNotificationRows = this.renderNotificationRows.bind(this);
  }
  componentWillMount() {
    if (!this.props.commonReducer.notificationsPageInfo) {
      this.props.actions.getNotificationAlerts(20, 0);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer && nextProps.commonReducer.isNotificationsLoaded && !this.state.isNotificationsLoaded) {
      this.setState({
        'isNotificationsLoaded': true
      });
    }
    if (nextProps.commonReducer && nextProps.commonReducer.loadedMoreNotifications) {
      this.loadingMoreNotifications = false;
    }
  }
  loadMoreNotificationCallback() {
    this.loadingMoreNotifications = true;
    if (this.props.commonReducer.notificationsPageInfo && this.props.commonReducer.notificationsPageInfo.rowCount) {
      this.props.actions.getNotificationAlerts(10, this.props.commonReducer.notifications.length, true);
    }
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  renderNotificationRows(notifications) {
    const notificationsView = map(notifications, (notification, key) => {
    console.log("notifications view = ",notification);
    if((notification.bookingId && notification.bookingId.substring(0,3) != 'EMG') || (notification.type === 'Job For The Day')){
      if (!notification.isRead) {
        const notificationDate = moment(notification.created_at).format('MMM DD, YYYY');
        const notificationTime = moment(notification.created_at).format('hh:mm A');
        let messageRead = false;
        if (indexOf(this.props.commonReducer.markedNotifications, notification.alertId) > -1) {
          messageRead = true;
        }
        let serviceType = '';
        if (notification.service) {
          serviceType = services[notification.service];
        } 
        else if (notification.bookingId) {
          if (notification.bookingId.indexOf('WSH') > -1) {
            serviceType = 'wash';
          } else if (notification.bookingId.indexOf('REP') > -1) {
            serviceType = 'repair';
          }
          else if (notification.bookingId.indexOf('SRV') > -1) {
            serviceType = 'service';
          }
        }
        else if (notification.type === 'Job For The Day') {
          serviceType = 'jobToday';
        }
        return (
          <div className={"alert-card " + serviceType} key={key} onClick={(e) => 
            {
               e.preventDefault(); 
               if (notification && notification.bookingId) {
                this.props.router.push(`${appBasePath}/job/${notification.requestId}`); 
               }
               else {
                this.props.router.push(`${appBasePath}/open-jobs/applied`); 
              }
               if (!messageRead) { 
                this.props.actions.markNotificationAsRead(notification.alertId) 
               } 
            }
          } style={{ backgroundColor: messageRead ? '#F9FBFB' : '#FFFFFF' }}>
            <div className="notification-card-content left">
              <h5>{notification.msg}</h5>
            </div>
            <div className="notification-card-content right">
              <span>{notificationDate}</span>
              <span>{notificationTime}</span>
            </div>
          </div>
        );
      }
     }
    });
    return notificationsView;
  }
  render() {
    const todayNotifications = filter(this.props.commonReducer.notifications, (notification) => { return notification.category == 'today' });
    const yesterdayNotifications = filter(this.props.commonReducer.notifications, (notification) => { return notification.category == 'yesterday' });
    const oldNotifications = filter(this.props.commonReducer.notifications, (notification) => { return notification.category == 'old' });
    const todayNotificationsView = this.renderNotificationRows(todayNotifications);
    const yesterdayNotificationsView = this.renderNotificationRows(yesterdayNotifications);
    const oldNotificationsView = this.renderNotificationRows(oldNotifications);
    console.log(" old notifications =  ", oldNotificationsView);
    return (
      <div>
        {/*Header*/}
        <Header searchMobile={this.state.searchMobile} hideOption={() => this.setState({ searchMobile: true })} commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="" notificationCallBack={this.toggleNotification} authReducer={this.props.authReducer}
          hCallback={() => { this.hclickCallBack() }} router={this.props.router} />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper">
          {/*Sidebar*/}
          <Sidebar showSidebar={this.state.showSidebar} router={this.props.router} actions={this.props.actions} commonReducer={this.props.commonReducer} authReducer={this.props.authReducer} />
          <div className="container-fluid main-container">
            <div className="col-md-9 mpad0 padr30">
              <div className="overview-heading">
                <h5>Notifications</h5>
              </div>
              <div className="content-view">
                {this.state.isNotificationsLoaded ?
                  this.props.commonReducer.unableToFetchNotifications
                    ? <div><h3>Unable to fetch notifications <a style={{ cursor: 'pointer' }} onClick={() => { this.props.actions.getNotificationAlerts(5) }}>Try Again</a></h3></div>
                    : (this.props.commonReducer.notifications && this.props.commonReducer.notifications.length > 0) ?
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={this.loadMoreNotificationCallback.bind(this)}
                        hasMore={(!this.loadingMoreNotifications && this.props.commonReducer.notificationsPageInfo && this.props.commonReducer.notificationsPageInfo.rowCount > this.props.commonReducer.notifications.length)}
                        loader={<div className="center"><PageLoader /></div>}>
                        <div>
                          <div className="notification-all-page">
                            {(todayNotifications && todayNotifications.length) ? <div className="notification-view-card">
                              <h4 className="notification-day">Today</h4>
                              {todayNotificationsView}
                            </div> : ''}
                            {(yesterdayNotifications && yesterdayNotifications.length) ? <div className="notification-view-card">
                              <h4 className="notification-day">Yesterday</h4>
                              {yesterdayNotificationsView}
                            </div> : ''}
                            {(oldNotifications && oldNotifications.length) ? <div className="notification-view-card">
                              <h4 className="notification-day">Old</h4>
                              {oldNotificationsView}
                            </div> : ''}
                          </div>
                        </div>
                      </InfiniteScroll>
                      : (<div><p>Looks like you dont have any notifications.</p></div>)
                  : <PageLoader />}
              </div>
            </div>
            <div className="col-md-3 mpad0 padLeft0">
              <Schedule commonReducer={this.props.commonReducer} router={this.props.router} />
            </div>
          </div>
        </div>
        {this.state.searchMobile && <div >

          <MobileHeaderSearch mobile={true} actions={this.props.actions} commonReducer={this.props.commonReducer} mobSearchClick={() => this.setState({ searchMobile: false })} />
        </div>}
      </div>
    )
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification/Notification.jsx